import React, { useState } from 'react';
import styled from 'styled-components';
import './App.css';
import LoginButton from './LoginButton'

function Home(props) {
  return (
    <div className={props.className}>
        <div>Homepage</div>
        <LoginButton />
    </div>
  );
}

export default styled(Home)`
  background: #f2f2f2;
  height: 100vh;
`;
